export const CITIZEN_INITIAL_FILTER_FIELDS = [
  'name',
  'social_name',
  'mother_name',
  'father_name',
  'cnpj_number',
  'cpf_number',
  'cns_number',
  'ctps_pis_number',
  'rg_number',
  'sex',
  'race',
  'ethnicity',
  // 'main_address_neighbourhood',
  'health_place_name',
  'school_place_name',
  'gov_place_name',
  'social_place_name',
  'origin_id',
  'jobsite_name',
]
